import { Checkbox } from "antd";
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { toast, ToastContainer } from "react-toastify";
// import CheckBox from "./ReactTableFiles/CheckBox";
// import ColumnFilter from "./ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import { TextField } from "@mui/material";
import { common_axios } from "../../../../App";
import CheckBox from "../../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import Backdrop from "@mui/material/Backdrop";
import Loader from "../../../../components/Loader";
import TableViewIcon from "@mui/icons-material/TableView";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { dateFormatter } from "../../../../helper/helper";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import SendIcon from '@mui/icons-material/Send';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import moment from "moment";
import dayjs from "dayjs";
import { actionid } from "../../../../redux/features/pageSlices";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
  Tooltip,
  InputAdornment
} from "@mui/material";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import RefreshIcon from "@mui/icons-material/Refresh";
import InfoIcon from "@mui/icons-material/Info";

import {
  mainSkelton,
  processlist,
  runninglist,
  schedulelist,
  stoppedlist,
} from "../../../../redux/features/pageSlices";
import { useDispatch } from "react-redux";
import Pagination from "@mui/material/Pagination";
import {
  Stack,
} from "@mui/material";
import Switch from '@mui/material/Switch';

export default function CreateCampaignAdmin({ processArray, open: open1, parentCallback, }) {
  const [open, setOpen] = useState();
  const [scheduledata, setScheduleData] = useState([]);
  const [ScheduleTotalCount, setScheduleTotalCount] = useState();
  const [hideSkeleton, sethideSkeleton] = useState();
  const [data1, setData1] = useState([]);
//   const [stoppedFun, setStoppedFun] = useState(true);
  const [processFun, setProcessFun] = useState(true);
  const datereff = useRef();

  const customId1 = "custom-id-yess";
//   const [stoppedFunState, setStoppedFunState] = useState();
  const [processFunState, setProcessFunState] = useState();
  const [value, setValue] = React.useState(
    moment(new Date()).subtract(5.5, "hours").add(20, "minutes")
  );
  const [TableStatus, setTableStatus] = useState({
    pageNo: 0,
    pageSize: 10,
  });
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  // console.log("totalPage----", ScheduleTotalCount);
  const [checkedRecurring, setCheckedRecurring] = React.useState(false);

  const handleChangetoogleRecurring = (event) => {
    setCheckedRecurring(event.target.checked);
    setStatusDropDown(null)
  };

  const [statusDropDown, setStatusDropDown] = React.useState("");
  const handleChangeRecurring = (event) => {
    setStatusDropDown(event.target.value);
  };
  const [viewDetails, setViewDetails] = useState(undefined);
 
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const [paginationPage, setPaginationPage] = React.useState(1);


  const [schedulebuttton, setScheduleButtton] = useState(undefined);
  const scheduleModal = useRef(null);

  const scheduledButtonModal = async (cell) => {
    await setScheduleButtton(cell.row.original);
    await scheduleModal.current.click();
  };


  const [sendButton, setSendButton] = useState(undefined);
// console.log("hhhh",sendButton)
  const sendbuttonModal = useRef(null);

  const sendModal = async (cell) => {
    await setSendButton(cell.row.original);
    await sendbuttonModal.current.click();
  };

  useEffect(() => {
    if (processArray?.content && processArray?.content.length > 0) {
      setData(processArray?.content);
      setData1(processArray);
    } else {
      setData([]);
    }
    // setTotalPage(processArray?.totalPages);
    // settotalPageCount(processArray?.pageable?.pageNumber);
  }, [processArray]);

  useEffect(() => {
    setProcessFunState(processFun);
  }, [processFun]);

  // ...........................Rfresh API....................//
  async function RefreshBtn(values) {
    // setTableLoader(true);
    sethideSkeleton(true);
    dispatch(mainSkelton(true));
    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/admin/v1/campaign/schedule/status`,
        {
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
        }
      );
      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        sethideSkeleton(false);
          setData(result.data.createdCampaign.content);
        await setData1(result.data?.createdCampaign);

        // await setTotalPage(result.data.scheduledList.totalPages);
        // await settotalPageCount(result.data.scheduledList.pageable.pageNumber);
        await setScheduleTotalCount(result.data.createdCampaign);

        dispatch(mainSkelton(false));
        dispatch(schedulelist(result?.data?.scheduled));
        dispatch(runninglist(result?.data?.running));
        dispatch(stoppedlist(result?.data?.stopped));
        dispatch(processlist(result?.data?.createdCampaign));

        // await toast.success("success", {
        //   theme: "colored",
        //   toastId: customId1,
        // });
      }  else if (result.data?.statusDescription?.statusCode == 220) {
        // alert("here");
        dispatch(mainSkelton(false));
        setScheduleTotalCount(null);
        dispatch(schedulelist([]));
        dispatch(runninglist([]));
        dispatch(stoppedlist([]));
        dispatch(processlist([]));
       
      } else {
        sethideSkeleton(false);
        dispatch(mainSkelton(false));
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      sethideSkeleton(false);
      dispatch(mainSkelton(false));

      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }
  // ...........................Status API....................//
  async function CreateCampaignPost(values) {
    // setTableLoader(true);
    setOpen(true);
    try {
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/admin/v1/campaign/schedule/status`,
        {
          pageNo: TableStatus?.pageNo,
          pageSize: TableStatus?.pageSize,
        }
      );
      // console.log("ret", result.data.stoppedList);
      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setData(result.data.createdCampaign.content);
        await setData1(result.data?.createdCampaign);
        dispatch(mainSkelton(false));
        dispatch(schedulelist(result?.data?.scheduled));
        dispatch(runninglist(result?.data?.running));
        dispatch(stoppedlist(result?.data?.stopped));
        dispatch(processlist(result?.data?.createdCampaign));

        // await setTotalPage(result.data.createdCampaign.totalPages);
        // await settotalPageCount(result.data.createdCampaign.pageable.pageNumber);
        await setScheduleTotalCount(result.data.createdCampaign);
        // await toast.success("success", {
        //   theme: "colored",
        //   toastId: customId1,
        // });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);
      setOpen(false);
      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
    // console.log("response..", res);
  }

  const columns = useMemo(
    () => [
        {
            Header:"Id",
            accessor: "id",
            Cell: (cell) => {
              // console.log("cell--", cell.row.index);
              return (
                <>
                  {cell.row.index +
                    1 +
                    TableStatus?.pageNo * TableStatus?.pageSize}
                </>
              );
            },
          },
          {
            Header: "Campaign Name",
    
            accessor: "eventName",
            Cell: (cell) => {
              return (
                <>
                  <div>{cell?.row?.original?.eventName}</div>
                  <div className="my-2 fw-bold" style={{ color: "#959595" }}>
                    {`(${cell?.row?.original?.username})`}
                  </div>
                </>
              );
            },
          },
      // {
      //   Header: "Campaign name",

      //   accessor: "eventName",
      // },
      {
        Header: "Start Date",

        accessor: "datetimeEntry", // accessor is the "key" in the data
        
      },
      {
        Header: "Sender Id",

        accessor: "senderId", // accessor is the "key" in the data
      
      },

    {
        Header: "Camp Type",

        accessor: "campaignType", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              {cell?.row?.original?.campaignType == "Promotional "  ? (
                <div className=""  >
                 P
                </div>
              ) : (
                <div className=""
                
                >
                 T
                </div>
              )}
            </>
          );
        },
      },
  
      {
        Header: "Message",
        accessor: "message", // accessor is the "key" in the data
        Cell: (cell) => {
          return (
            <>
              {cell?.row?.original?.message?.length >= 60 ? (
                <div className="">
                  <div className="showMoreTd">
                  {cell.row.original?.[`Show`] == true
                      ? cell?.row?.original?.message?.slice(0, 60) + "..."
                      : cell?.row?.original?.message}
                  </div>
                  <button
                    className="showMore"
                    onClick={() => {
                      // Showdata?.[`Show${cell.row.index}`];

                      const dataaa = [...data];

                      dataaa[cell.row.index][`Show`] =
                        !cell.row.original?.[`Show`];

                      setData(dataaa);
                    }}
                  >
 {cell.row.original?.[`Show`]== true ? "More" : "Less"}      
             </button>
                </div>
              ) : (
                <div className="showMoreTd">{cell.row.original.message}</div>
              )}
            </>
          );
        },
      },

      {
        Header: "Action",
        accessor: "action",
        Cell: (cell) => (
          <div className="dropdown">

        <button
          className="btn color_1 p-0 px-1"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          onClick={() => {
                 scheduledButtonModal(cell);
              }}
        >
                     <Tooltip title="Scheduled">

                      <EventAvailableIcon className="color_red_UP me-2" />
                      </Tooltip>
        </button>
        <button
          className="btn color_1 p-0 px-1"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          onClick={() => {
            // alert("jjjj")
             sendModal(cell);
          }}
        >
                                <Tooltip title="Send Now">
                  <SendIcon className="color_Green_UP me-2" />
                                      </Tooltip>
        </button>
      
      </div>
        ),

        disableFilters: true,
      },
  
    ],
    [TableStatus, data]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
   
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  useEffect(() => {
    // if (TableStatus?.pageNo != 0 || TableStatus?.pageSize != 10) {
    //   // StopPost();
    // }
    if (processFunState == false) {
        CreateCampaignPost();
    }
  }, [TableStatus.pageSize, TableStatus.pageNo]);


  async function ScheduleNow() {
    // setData([]);
    try {
      setOpen(true);

      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/campaign/send-now/or/schedule`,

        // "http://192.168.167.66:5002/v1/get-all/DND/file",

        {
            campaignId: schedulebuttton?.id,
            flag: "Scheduled",
            scheduledDatetime: moment(value)?.format(
                "YYYY-MM-DD HH:mm:ss"
              ),
              campaignType: checkedRecurring == true ? "Recurring Campaign" : "Individual",
              reccuringType: statusDropDown,


        }
      );

      // console.log("result get api.........", result);

      if (result.data.statusDescription.statusCode == 200) {
        setOpen();
                CreateCampaignPost()

        dispatch(actionid("1"));
      } else {
        setOpen();
        // toast.error(result.data.statusDescription.statusdescription);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  async function SendNow() {
    // setData([]);
    try {
      setOpen(true);

      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/campaign/send-now/or/schedule`,

        // "http://192.168.167.66:5002/v1/get-all/DND/file",

        {
            campaignId: sendButton.id,
            flag: "SendNow",
          
        }
      );

      // console.log("result get api.........", result);

      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        CreateCampaignPost()

        dispatch(actionid("-1"));

      } else {
        setOpen(false);
        // toast.error(result.data.statusDescription.statusdescription);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    parentCallback(ScheduleTotalCount);
  }, [ScheduleTotalCount]);
  return (
    <div>
      <div>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
      </div>
      {schedulebuttton != undefined && (
        <div>
          <button
            ref={scheduleModal}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop208"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop208"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdrop208Label"
            aria-hidden="true"
          >
            <div className="modal-dialog" style={{width:'28%', maxWidth:'100%',}}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdrop208Label">
                  schedule sms later
                  </h5>
                  <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
                </div>

             <div className="modal-body">
             <div>
                              <span className="fw-bold">Is it recurring Campaign?</span>
                              <Switch
      checked={checkedRecurring}
      onChange={handleChangetoogleRecurring}

      inputProps={{ 'aria-label': 'controlled' }}
    />

                              </div>
                              <div className="my-4 mt-2">
{
  checkedRecurring == true ? (<>    
  
    <div className="col-md-4">
<FormControl required fullWidth size="small">
                          <InputLabel id="demo-simple-select-autowidth-label">
                            Recurring
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={statusDropDown}

                             onChange={handleChangeRecurring}
                            autowidth
                            label="Recurring"
                          >
                            <MenuItem value="daily">Daily</MenuItem>
                            <MenuItem value="weekly">Weekly</MenuItem>
                            <MenuItem value="monthly">Monthly</MenuItem>

                          </Select>
                        </FormControl>
  </div>
        
                        </>):(<>

  </>)
}
</div>            

                             <div>
                                <>
                                  {" "}
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                    style={{ zIndex: "10px" }}
                                    // inputRef={datereff}
                                  >
                                    <DateTimePicker
                                      inputRef={datereff}
                                      disablePast
                                      // minDate={dayjs(new Date())}
                                      minTime={moment(new Date())
                                        .subtract(5.5, "hours")
                                        .add(15, "minutes")}
                                      // minTime={moment().add(15,"minutes")}
                                      renderInput={(props) => (
                                        <TextField
                                          size="small"
                                          required
                                          style={{ zIndex: "10px" }}
                                          {...props}
                                          helperText={
                                            "(Date time should be mm/dd/yyyy hh:mm)"
                                          }
                                        />
                                      )}
                                      ampm={false}
                                      style={{ zIndex: "10px" }}
                                      label="Select Schedule"
                                      value={value}
                                      onChange={(newValue) => {
                                        setValue(newValue?.$d);
                                        // console.log("ee",newValue)
                                      }}
                                    />
                                  </LocalizationProvider>
                                </>
                                </div>
                              </div>
                              <div className="modal-footer mt-3 justify-content-between align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-secondary m-0"
                                  data-bs-dismiss="modal"
                                  onClick={() => {
                                    // setValue(null);
                                    setCheckedRecurring("")
                                  setStatusDropDown("")
                                  }}
                                >
                                  Close
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-primary m-0 ms-2"
                                  data-bs-dismiss="modal"
                                  onClick={ScheduleNow}
                                >
                                  Submit Campaign
                                </button>
                              </div>
                {/* <div class="modal-footer"> */}

                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      )}

      {sendButton != undefined && (
        <div>
          <button
            ref={sendbuttonModal}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop308"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop308"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdrop308Label"
            aria-hidden="true"
          >
            <div className="modal-dialog" style={{width:'27%', maxWidth:'100%',}}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdrop308Label">
                    Are you sure you want to send this?

                  </h5>
                  <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
                </div>

                <div className="modal-body">
                <div className="modal-footer justify-content-between border-0">
                                  <button
                      type="button"
                      className="btn btn-secondary shadow"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary editcolor shadow okbtn px-4"
                      data-bs-dismiss="modal"
                   onClick={SendNow}
                    >
                      Send
                    </button>
                   
                  </div>
                </div>
                {/* <div class="modal-footer"> */}

                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      )}

      {data?.length > 0 ? (
        <>
          <div className="card-body">
            <div className="card shadow-none border bg_blue mt-4">
              <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                {/* Add Number */}
                Campaign Created
              </span>
              {hideSkeleton == true ? (
                <>
                  <Box sx={{ width: "100%" }}>
                    <Skeleton />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    {/* <Skeleton animation={false} /> */}
                  </Box>
                </>
              ) : (
                <>
                  {/* <div className="d-flex justify-content-end align-items-center px-4 mt-2">
                    
                    
                  </div> */}

                  <div class="card-body">
                    <div className="d-flex justify-content-between mb-3">
                      <select
                        value={TableStatus.pageSize}
                        className="dropdown"
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                          setTableStatus({
                            ...TableStatus,
                            pageSize: e.target.value,
                            pageNo:0

                          });
                          setProcessFunState(false)
                          setPaginationPage(1)
                        }}
                      >
                        {[10, 25, 50].map((value, i) => {
                          return (
                            <option
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                              value={value}
                              key={value}
                            >
                              Show {value}
                            </option>
                          );
                        })}
                      </select>

                      <button
                      type="submit"
                      className="btn bg-gradient-primary w_btn m-0 search_1 "
                      onClick={RefreshBtn}
                      // onClick={() => RefreshBtn("Text to Copy")}
                    >
                      {/* <i class="material-icons opacity-10">refresh</i> */}
                      <RefreshIcon />
                    </button>
                      {/* <div className="d-flex align-items-center">

                    <TextField
                      className="ms-4 w-100"
                      style={{
                        borderRadius: "4px",
                      }}
                      type="text"
                      label="Search"
                      name="Search"
                      variant="outlined"
                      // value={number}
                      size="small"
                      value={globalSearchValue || ""}
                      onChange={(e) => {
                        onChange(e.target.value);
                        setGlobalSearchValue(e.target.value);
                      }}
                    />
                  </div> */}
                    </div>

                    <div>
                      {selectedFlatRows.length > 0 && (
                        <button onClick={deletUser}>Delete Users</button>
                      )}

                      {/* <button onClick={changeOrder}>Change Order</button> */}
                    </div>
                    <div className="table-responsive">
                      <table
                        {...getTableProps()}
                        id="example"
                        className="table table-striped table-bordered dataTable table-sm"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                              {headerGroup.headers.map((column) => (
                                <th
                                  {...column.getHeaderProps(
                                    column.getSortByToggleProps()
                                  )}
                                  className={
                                    column?.Header == "Message"
                                      ? "text-center width_2 update_th messageWidth"
                                      : column?.Header == "Camp Type"
                                      ? "text-center width_2 update_th_sp d-flex border-start-0"
                                      : "text-center width_2 update_th_sp "
                                  }                                >
                                  {column.render("Header")}
                                  <span>
                                    {column.isSorted
                                      ? column.isSortedDesc
                                        ? "↑"
                                        : "↓"
                                      : ""}
                                  </span>
                                  {column.Header == "Camp Type" ? (
                                    <>
                                      <InputAdornment
                                        position="end"
                                        className="my-auto"
                                      >
                                        <Tooltip
                                          title={"P-Promotional T-Transactional"
                                            .split(" ")
                                            .map((arg) => {
                                              return (
                                                <>
                                                  {arg}
                                                  <br />
                                                </>
                                              );
                                            })}
                                          id="toolTipId"
                                          placement="top"
                                          arrow
                                          sx={{ color: "white" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody class='onhover_change'{...getTableBodyProps()} id="svg_tbody">
                          {/* {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()} className="text-center">
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })} */}

                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                  return (
                                    <td
                                      {...cell.getCellProps()}
                                      // className="text-start"
                                      className={
                                  (cell.column.Header == "SMS count" ||
                                    cell.column.Header == "Sender Id"  ) ?
                                  "text-end" 
                                  :
                                  (cell.column.Header=="Action" ||
                                  cell.column.Header=="Camp Type" ||
                                   cell.column.Header=="Status") ?
                                   "text-center":
                                  "text-start"
                                }    
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                        {/* <tfoot>
          {footerGroups.map((footerGroup) => (
            <tr {...footerGroup.getFooterGroupProps()}>
              {footerGroup.headers.map((column) => (
                <td className="text-center" {...column.getFooterProps}>
                  {column.render("Footer")}
                </td>
              ))}
            </tr>
          ))}
        </tfoot> */}
                      </table>
                    </div>

                    <div className="d-flex justify-content-between">
                      <div>
                        <span>
                          Page:
                          <strong>
                            {data1?.pageable?.pageNumber + 1} of{" "}
                            {data1?.totalPages}
                          </strong>
                        </span>
                      </div>




                      <div className="prev_next d-flex align-items-center">
                <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root m-0"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      //  disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                       
                        setTableStatus({
                          ...TableStatus,
                          pageNo:0,
                        });
                        setPaginationPage(1)
                      }}
                    >
                      First
                    </button>

                <Stack spacing={2}>
              <Pagination
                onChange={(event, value) => {
                  console.log("va--", value);
                  setTableStatus({
                    ...TableStatus,
                    pageNo: Number(value) - 1,
                  });
                  setPaginationPage(value);
                  setProcessFunState(false);

                }}
                page={paginationPage}
                count={data1 ? data1?.totalPages : ""}
               
                variant="outlined"
                shape="rounded"
                
            color="primary"
              />
            </Stack>
            <button
                      className="css-21ve8j css-r93niq-MuiButtonBase-root-MuiPaginationItem-root ms-2"
                      type="button"
                      // style={{ background: "#2C97D4" }}
                      // disabled={
                      //   data1?.totalPages == data1?.pageable?.pageNumber + 1
                      //  }
                      onClick={() => {
                        // alert("gg")
                        setTableStatus({
                          ...TableStatus,
                          pageNo:data1?.totalPages -1 ,
                        });
                        setPaginationPage(data1?.totalPages)
                      }}
                    >
                      Last
                    </button>
              </div>
{/* 
                      <div className="btn_n800">
                        <button
                          className="btn btn_primary "
                          type="button"
                          style={{ background: "#2C97D4" }}
                          disabled={data1?.pageable?.pageNumber == 0}
                          onClick={() => {
                            setTableStatus({
                              ...TableStatus,
                              pageNo: TableStatus.pageNo - 1,
                            });
                            setProcessFunState(false);
                          }}
                        >
                          Prev
                        </button>

                        <button
                          className="btn btn_primary ms-2"
                          type="button"
                          style={{ background: "#2C97D4" }}
                          disabled={
                            data1?.totalPages == data1?.pageable?.pageNumber + 1
                          }
                          onClick={() => {
                            setTableStatus({
                              ...TableStatus,
                              pageNo: TableStatus.pageNo + 1,
                            });
                            setProcessFunState(false);
                          }}
                        >
                          Next
                        </button>
                      </div> */}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="text-center mt-4">
            {data?.length == 0 && open1 ? null : (
              <div className="text-center">
                <h5>No Record Found..!!</h5>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
